var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocStopoverFlag1WhiteC82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "evenodd",
    d: "M12 1.5v3h4.5v30h-15v-30H6v-3h6zM15 6H3v27h12V6zm-1.5 21.75v3.75h-9v-3.75h9zM21.75 15v19.5h-1.5V15h1.5zm1.5 0l11.25 5.625L23.25 24v-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocStopoverFlag1WhiteC82);
export default __webpack_public_path__ + "static/media/soc_stopover_flag_1_white_C8.2.8698a0daa81e386a6ae5267de030a86c.svg";
export { ForwardRef as ReactComponent };